/* eslint-disable camelcase */
export var ProjectIndustryAttribute;
(function (ProjectIndustryAttribute) {
    ProjectIndustryAttribute["affiliate"] = "affiliate";
    ProjectIndustryAttribute["b2b"] = "b2b";
    ProjectIndustryAttribute["b2b2c"] = "b2b2c";
    ProjectIndustryAttribute["b2c"] = "b2c";
    ProjectIndustryAttribute["brick_mortar"] = "brick_mortar";
    ProjectIndustryAttribute["e_commerce"] = "e_commerce";
    ProjectIndustryAttribute["lead_generation"] = "lead_generation";
    ProjectIndustryAttribute["multi_country"] = "multi_country";
    ProjectIndustryAttribute["multi_domain"] = "multi_domain";
    ProjectIndustryAttribute["pure_player"] = "pure_player";
})(ProjectIndustryAttribute || (ProjectIndustryAttribute = {}));
//# sourceMappingURL=project.attribute.js.map